import { BrowserModule } from "@angular/platform-browser";
import { NgModule } from "@angular/core";

import { HttpClientModule, HTTP_INTERCEPTORS } from "@angular/common/http";

import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { AuthService } from "./services/auth.service";
import { AuthInterceptorService } from "./services/auth-interceptor.service";
import { HomeComponent } from "./home/home.component";
import { AuthenticationAuthorizationModule } from "./sign-in/authentication-authorization.module";
import { CoreModule } from "./core/core.module";
import { SupplierModule } from "./supplier/supplier.module";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { DocumentsModule } from "./documents/documents.module";
import { NgxDocViewerModule } from "ngx-doc-viewer";
import { ComplianceRegulationsComponent } from "./compliance-regulations/compliance-regulations.component";
import { NgxSummernoteModule } from "ngx-summernote";
import { MatIconModule } from "@angular/material/icon";
import { MatButtonModule } from "@angular/material/button";
import { FormsModule } from "@angular/forms";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { QRCodeModule } from "angularx-qrcode";
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {
  MSAL_INSTANCE,
  MSAL_INTERCEPTOR_CONFIG,
  MSAL_GUARD_CONFIG,
  MsalBroadcastService,
  MsalService,
  MsalGuard,
  MsalRedirectComponent,
} from "@azure/msal-angular";

import { MSALGuardConfigFactory, MSALInstanceFactory, MSALInterceptorConfigFactory } from "./sign-in/msal-factory";
import { MsalAuthGaurd } from "./sign-in/activate-guad";
import { QrBrandingComponent } from './qr-branding/qr-branding.component';
import { DowntimeBannerComponent } from './home/downtime-banner/downtime-banner.component';


const isIE =
  window.navigator.userAgent.indexOf("MSIE ") > -1 ||
  window.navigator.userAgent.indexOf("Trident/") > -1;



@NgModule({
  declarations: [AppComponent, HomeComponent, ComplianceRegulationsComponent, QrBrandingComponent, DowntimeBannerComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AuthenticationAuthorizationModule,
    AppRoutingModule,
    CoreModule,
    SupplierModule,
    DocumentsModule,
    NgxDocViewerModule,
    NgxSummernoteModule,
    MatIconModule,
    MatButtonModule,
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    QRCodeModule,
    MatProgressSpinnerModule
  ],
  providers: [
    {
      provide: MSAL_INSTANCE,
      useFactory: MSALInstanceFactory,
    },
    {
      provide: MSAL_GUARD_CONFIG,
      useFactory: MSALGuardConfigFactory,
    },
    {
      provide: MSAL_INTERCEPTOR_CONFIG,
      useFactory: MSALInterceptorConfigFactory,
    },
    MsalService,
    MsalAuthGaurd,
    MsalGuard,
    MsalBroadcastService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptorService,
      multi: true,
    },
  ],

  bootstrap: [AppComponent, MsalRedirectComponent],
})
export class AppModule {}
